<template>
  <div class="small-12 medium-12 large-4 columns newcolumn">
    <div class="nnoticia_wrapper" data-equalizer-watch="mrow">
      <div class="nnoticia_content">
        <router-link 
          :to="{ path: `/noticiassas/${noticia.noticia_name}` }" 
          class="noticia_img"
          :style="{ backgroundImage: 'url(' + noticia.imagem + ')' }"
          :data-src="noticia.imagem" />
        <router-link 
          :to="{ path: `/noticiassas/${noticia.noticia_name}` }"
          class="noticia_title">
            {{ noticia.noticia_titulo }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["noticia"],
  setup() {


    return {}
  }
}
</script>

<style lang="scss" scoped>
.newcolumn {
  position: relative;
  padding-left: 0;
  padding-right: 0;
}

.newcolumn:nth-of-type(1) {
  margin-left: 0;
}

.nnoticia_wrapper {
  border: 1px solid white;
  margin-right: 10px;
  background: white;
  margin-bottom: 27px;
}

.newcolumn:nth-of-type(2) .nnoticia_wrapper{
  margin-left: 5px;
  margin-right: 5px;
}

.newcolumn:nth-of-type(3) .nnoticia_wrapper{
  margin-right: 0;
  margin-left: 10px;
}

.nnoticia_content {
  border: 1px solid white;
  margin: 8px;
  margin-bottom: 55px;
}

.noticia_img {
  height: 0;
  padding: 0;
  padding-bottom: 64%;
  background-position: top center;
  background-size: 100%;
  background-repeat: no-repeat;
  display: block;
}

.nnoticia_wrapper .noticia_img {
  position: relative;
  background-size: cover;
}

.noticia_img:after {
  -webkit-transition: opacity .5s ease-in-out;
  transition: opacity .5s ease-in-out;
  content: "";
  position: absolute;
  height: 0;
  padding: 0;
  padding-bottom: 64%;
  background-position: top center;
  background-size: 100%;
  background-color: #000;
  opacity: 0.1;
  width: 100%;
}

.noticia_title {
  display: block;
  margin-top: 20px;
  margin-left: 5px;
  letter-spacing: 0.2px;
  padding-top: 3px;
  font-size: 20px;
  font-family: "Montserrat Bold";
  color: #454648;
  padding-right: 10px;
  padding-left: 10px;
}

.noticia_title:hover {
  color: black;
}

.noticia_img:hover:after {
  opacity: 0.6;
  -webkit-transition: opacity .5s ease-in-out;
  transition: opacity .5s ease-in-out;
}

.noticiassection .morelinks {
  color: #6eb7ec;
  text-transform: uppercase;
  margin-top: 0px;
  display: flex;
  font-size: 15px;
  align-items: center;
}

@media only screen and (max-width: 1439px) {
  .nnoticia_content {
    margin-bottom: 30px;
  }
}

@media (max-width: 1439px) {
  .noticia_title {
    font-size: 17.5px;
    line-height: 1.75;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {

  .noticia_img:after {}

  .newsrow .newcolumn:nth-of-type(2) .nnoticia_wrapper {
    margin-left: 0px;
  }

  .nnoticia_wrapper {
    margin-right: 0px !important;
  }

  .nnoticia_content {
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
  }

  .nnoticia_content a {
    width: 50%;
    flex: 1 50%;
    max-width: 50%;
    display: flex;
  }

  .noticia_img {
    padding-bottom: 32%;
  }

  .noticia_title {
    color: #454648;
    margin-top: 20px;
    font-size: 16px;
    line-height: 1.85;
    padding-right: 20px;
    padding-left: 20px;
  }
}


@media (max-width: 767px) {
  #mainrow {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .nnoticia_content {
    margin: 5px !important;
  }

  .noticia_title {
    color: #454648;
    margin-top: 20px;
    font-size: 15px;
    margin-bottom: 25px;
  }

  .noticiassection .newsrow .newcolumn .nnoticia_wrapper {
    margin-right: 0;
    margin-left: 0px;
  }

  .noticiassection {
    padding-top: 60px;
    margin-bottom: 0px;
  }

  .noticiassection .morelinks {
    margin-top: 0px;
  }

  .noticiassection {
    padding-bottom: 55px;
  }

}
</style>